export default {
    getEDocAdditionalConfig : state => state.eDocAdditionalConfig,
    getEDocTableSearchFields : state => state.eDocTableSearchFields,
    getEDocTableActions : state => state.eDocTableActions,
    getEDocTableRowActions : state => state.eDocTableRowActions,
    getEDocTableHeaderFields : state => state.eDocTableHeaderFields,
}